/**
 * Fetch wrapper that injects the Heady identity headers on every call.
 */
export interface HeadyCtx { userId: string; teamId: string }

// Brand-session team id (the logged-in tenant_id), set by App once /api/auth/me
// resolves. Used as the x-heady-team-id fallback so a brand user with no SDK
// context can still reach requireTeam-gated directory routes (PR #48a). Cleared
// on sign-out. SDK ctx.teamId, when present, always wins.
let brandTeamId: string | null = null;
export function setBrandTeamId(id: string | null): void {
  brandTeamId = id;
}

async function req(
  ctx: HeadyCtx | null,
  method: string,
  url: string,
  body?: any,
  init?: RequestInit
): Promise<any> {
  const headers: Record<string, string> = {
    "x-heady-user-id": ctx?.userId || "standalone-user",
    "x-heady-team-id": ctx?.teamId || brandTeamId || "standalone-team",
    ...(init?.headers as Record<string, string> | undefined),
  };
  if (body !== undefined) headers["Content-Type"] = "application/json";
  const res = await fetch(url, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    ...init,
  });
  const ct = res.headers.get("content-type") || "";
  if (!res.ok) {
    let msg = res.statusText;
    try {
      if (ct.includes("json")) {
        const j = await res.json();
        msg = j.message || j.error || msg;
      } else {
        msg = await res.text();
      }
    } catch {}
    throw new Error(`${res.status}: ${msg}`);
  }
  if (ct.includes("json")) return res.json();
  if (ct.includes("text/csv")) return res.blob();
  return res.text();
}

export const api = {
  get: (ctx: HeadyCtx | null, url: string) => req(ctx, "GET", url),
  post: (ctx: HeadyCtx | null, url: string, body?: any) => req(ctx, "POST", url, body),
  patch: (ctx: HeadyCtx | null, url: string, body?: any) => req(ctx, "PATCH", url, body),
  del: (ctx: HeadyCtx | null, url: string, body?: any) => req(ctx, "DELETE", url, body),
  exportCsv: async (ctx: HeadyCtx | null) => {
    const blob = await req(ctx, "GET", "/api/export.csv");
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "storesync.csv";
    a.click();
    URL.revokeObjectURL(url);
  },
};
